export default __webpack_public_path__ + "static/properties-light-mode-b47693d9b863e966788c6a718196a183.png";